import _asyncToGenerator from "D:/JG/jg/IWMS5.0/SRM/GIT/SRM.VUE/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _objectSpread from "D:/JG/jg/IWMS5.0/SRM/GIT/SRM.VUE/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import "regenerator-runtime/runtime.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.object.to-string.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { CreateInnerBoxCodeData, CreatePartDetailData, GetPartBarcodeDetailList, GetPartBarcodeDetailPageList } from '@/api/DeliveryCode';
import { GetDetailList } from '@/api/MaintainDeliveryNote2';
import { mapActions, mapGetters } from 'vuex';
import XEUtils from 'xe-utils';
import util from '@/libs/util';
import changeOrderDialog from './changeOrderDialog';
export default {
  components: {
    changeOrderDialog: changeOrderDialog
  },
  mounted: function mounted() {},
  data: function data() {
    var DELIVERY_QTYValid = function DELIVERY_QTYValid(cellValue) {
      var DELIVERY_QTY = Number(cellValue.DELIVERY_QTY);

      if (DELIVERY_QTY === 0) {
        return new Error('货数量数量不能为0');
      }
    };

    var SPQValid = function SPQValid(cellValue) {
      // console.log('cellValue',cellValue);
      // console.log(cellValue.row.DELIVERY_QTY);
      var SPQ = Number(cellValue.cellValue);
      var QTY = cellValue.row.DELIVERY_QTY; // console.log('SPQ',SPQ);
      // console.log('QTY',QTY);

      if (SPQ === 0) {
        return new Error('内包装数量不能为0');
      } else if (SPQ > QTY) {
        return new Error('内包装数量不能大于送货数量');
      }
    };

    return {
      tabelData: [],
      columnConfig: {
        resizable: true
      },
      pageInfo: {
        TotalCount: null,
        PageSize: 10,
        PageIndex: 1
      },
      loading: false,
      editConfig: {
        trigger: null,
        mode: null,
        showStatus: true
      },
      tableHeaderInfo: {},
      canEdit: false,
      vxeRules: {
        DELIVERY_QTY: [{
          required: true,
          message: '送货数量必须填写'
        }, {
          validator: DELIVERY_QTYValid
        }],
        SPQ: [{
          required: true,
          message: '内箱包装数量必须填写'
        }, {
          validator: SPQValid
        }]
      },
      isShowChangeOrderDialog: false,
      isShowPageBar: true,
      isShowOptionColumn: false,
      formData: {
        ID: null,
        DELIVERY_NO: null,
        // 送货单号
        DESCRIPTION: null,
        // 备注
        CREATETIME: null,
        // 创建日期
        VENDOR_CODE: null,
        // 供应商代码
        VENDOR_NAME: null // 供应商名称

      },
      userInfo: JSON.parse(util.cookies.get('userInfo')),
      orderInfo: null,
      submitID: null
    };
  },
  methods: _objectSpread(_objectSpread({}, mapActions('DeliveryNote/DeliveryNote', ['setOrderStatu'])), {}, {
    vxeFormatDate: function vxeFormatDate(_ref) {
      var cellValue = _ref.cellValue;
      return XEUtils.toDateString(cellValue, 'yyyy-MM-dd');
    },
    // 单行打印
    handleRowPrint: function handleRowPrint(row) {
      console.log('点击单行', row);
      this.$emit('handleRowPrint', row);
    },
    // 设置ID
    setID: function setID(id) {
      this.submitID = id;
    },
    // 打开选择送货单dialog
    ShowChangeOrderDialog: function ShowChangeOrderDialog() {
      var _this = this;

      this.isShowChangeOrderDialog = true;
      this.$nextTick(function () {
        _this.$refs.changeOrderDialog.getOrderlist();
      });
    },
    // 组合打印前校验
    valiPrintParBarcodeGroup: function valiPrintParBarcodeGroup(ID) {
      var _this2 = this;

      return new Promise( /*#__PURE__*/function () {
        var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(resolve) {
          var params, res;
          return regeneratorRuntime.wrap(function _callee$(_context) {
            while (1) {
              switch (_context.prev = _context.next) {
                case 0:
                  params = {
                    Page: 1,
                    Limit: 10,
                    MST_ID: ID,
                    ORGANIZE_ID: util.cookies.get('ORG_ID')
                  };
                  _this2.loading = true;
                  _context.next = 4;
                  return GetPartBarcodeDetailPageList(params);

                case 4:
                  res = _context.sent;
                  _this2.loading = false;
                  console.log('组合打印前校验', res);

                  if (res.code === 0) {
                    if (res.data.Items.length === 0) {
                      resolve(false);
                    } else {
                      resolve(true);
                    }
                  }

                case 8:
                case "end":
                  return _context.stop();
              }
            }
          }, _callee);
        }));

        return function (_x) {
          return _ref2.apply(this, arguments);
        };
      }());
    },
    // 获取标签List
    GetPartBarcodeDetailList: function GetPartBarcodeDetailList(orderInfo) {
      var _this3 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var params, res;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _this3.orderInfo = orderInfo;
                params = {
                  Page: _this3.pageInfo.PageIndex,
                  Limit: _this3.pageInfo.PageSize,
                  // MST_ID: this.submitID ? this.submitID : this.orderInfo.ID,
                  MST_ID: _this3.orderInfo ? _this3.orderInfo.ID : _this3.submitID,
                  ORGANIZE_ID: util.cookies.get('ORG_ID')
                };
                _this3.loading = true;
                _context2.next = 5;
                return GetPartBarcodeDetailPageList(params);

              case 5:
                res = _context2.sent;
                _this3.loading = false;
                console.log('标签List', res);

                if (res.code === 0) {
                  _this3.tabelData = res.data.Items;

                  _this3.$emit('cbGetPartBarcodeDetailList', res);

                  _this3.pageInfo.TotalCount = res.data.TotalCount;
                  _this3.pageInfo.PageSize = res.data.PageSize;
                  _this3.pageInfo.PageIndex = res.data.PageIndex;
                }

              case 9:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }))();
    },
    // 生成标签
    handleCreateOutBoxBarcode: function handleCreateOutBoxBarcode(TabelHeaderData) {
      var _this4 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
        var params, res, res2;
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                // console.log(this.formData);
                // console.log('this.submitID',this.submitID);
                params = {
                  ID: _this4.submitID ? _this4.submitID : _this4.orderInfo.ID,
                  CREATORID: _this4.userInfo.USER_NAME,
                  ORGANIZE_ID: util.cookies.get('ORG_ID')
                };
                console.log('params', params);
                _context3.next = 4;
                return CreatePartDetailData(params);

              case 4:
                res = _context3.sent;
                console.log('res', res);

                if (!(res.code === 0)) {
                  _context3.next = 14;
                  break;
                }

                _context3.next = 9;
                return CreateInnerBoxCodeData(params);

              case 9:
                res2 = _context3.sent;
                console.log('res2', res2);

                _this4.GetPartBarcodeDetailList(TabelHeaderData);

                _context3.next = 15;
                break;

              case 14:
                _this4.$message.warning(res.message);

              case 15:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      }))();
    },
    // 明细dialog确定按钮回调
    cbDialogSubmit: function cbDialogSubmit(selectRecords) {
      // console.log(selectRecords);
      this.formData.ID = selectRecords.ID;
      this.formData.DELIVERY_NO = selectRecords.DELIVERY_NO;
      this.formData.DESCRIPTION = selectRecords.DESCRIPTION;
      this.formData.CREATETIME = selectRecords.CREATETIME;
      this.formData.VENDOR_CODE = selectRecords.VENDOR_CODE;
      this.formData.VENDOR_NAME = selectRecords.VENDOR_NAME; // this.Bus.emit('onSelectOrderForOuterBox',selectRecords)

      this.$emit('onDialogSubmit_OuterBoxLabelManagement', selectRecords);
    },
    // 明细dialog关闭
    closeChangeOrderDialog: function closeChangeOrderDialog() {
      this.isShowChangeOrderDialog = false;
    },
    // 点击页码
    handleCurrentChange: function handleCurrentChange(index) {
      this.pageInfo.PageIndex = index;
      this.GetPartBarcodeDetailList(this.orderInfo);
    },
    // 切换页码
    handleSizeChange: function handleSizeChange(value) {
      // console.log(value);
      this.pageInfo.PageSize = value;
      this.GetPartBarcodeDetailList(this.orderInfo);
    }
  }),
  watch: {
    $DeliveryCodeOrderState: {
      handler: function handler(nawValue) {
        if (nawValue === 'listShow') {
          this.tabelData = [];
        }
      },
      immediate: true
    }
  },
  computed: _objectSpread({}, mapGetters(['$DeliveryCodeOrderState', 'userinfo'])),
  beforeDestroy: function beforeDestroy() {
    console.log('销毁');
    this.setOrderStatu('listShow');
    this.Bus.off('onBeforeSaveEditOrder');
    this.Bus.off('onShowAddRowDialog');
    this.Bus.off('onClickaddOrder');
  }
};